module.exports = __webpack_public_path__ + "static/img/report_bg2.787b58cf.png";